import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { gerAdminEmployersMetricsRoute } from '../api/constant';
import { assignedEmployer } from '../constants';

type useGetEmployerMatricsProps = {
    enterprise_id: number | undefined | null;
    company_id: number | undefined | null;
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useGetEmployerMatrics = ({
    enterprise_id,
    company_id,
    setAlertText = () => { },
}: useGetEmployerMatricsProps) => {
    const client = useQueryClient();

    const queryParams = new URLSearchParams();
    if (enterprise_id) {
        queryParams.append('enterprise_id', enterprise_id.toString());
    }
    if (company_id) {
        queryParams.append('company_id', company_id.toString());
    }

    const { data: companyData, isFetching: isLoadingCompanyData } = useQuery({
        queryKey: [company_id, enterprise_id, assignedEmployer],
        queryFn: () =>
            axiosInstance
                .get(`${gerAdminEmployersMetricsRoute}?${queryParams.toString()}`)
                .then((res) => res.data),
        onSuccess: (data) => {
            if (data.status !== 200) {
                setAlertText(data.message);
            } else {
                setAlertText('');
            }
        },
        onError: () => {
            setAlertText(errorMessage);
            // client.invalidateQueries([assignedEmployer]);
        },
        refetchOnWindowFocus: false,
    });

    return {
        companyData,
        isLoadingCompanyData,
    };
};
